import { Euler, Quaternion, Vector3 } from 'three';
import { degresToRad } from '../../../helpers/angles';

export interface Keyframes {
	positions: Vector3[];
	rotations: Quaternion[];
}

export interface CameraKeyframes {
	positions: Vector3[];
	lookAtPosition: Vector3[];
}

export const cameraKeyframes: CameraKeyframes = {
	positions: [
		new Vector3(2.5, 0.4, 2.5), // front view
		new Vector3(3.0, 2.8, 3.6), // heel view
		new Vector3(-0.3, 6, 0), // lattice view (same as top view)
		new Vector3(-1.2, 6, 0), // top view
	],
	lookAtPosition: [
		new Vector3(0, -0.1, 0), // front view
		new Vector3(0, 0, 0), // heel view
		new Vector3(-0.2, 1.2, 0), // lattice view (same as top view)
		new Vector3(-0.2, 0.2, 0), // top view
	],
};

export const leftInsoleKeyframes: Keyframes = {
	positions: [
		new Vector3(-0.17, 0, -0.47), // front view
		new Vector3(0, 0.345, -0.025), // heel view
		new Vector3(0.07, 0.55, 0.4), // lattice view (same position as top view)
		new Vector3(0.07, 0.1, -0.3), // top view
	],
	rotations: [
		new Quaternion().setFromEuler(new Euler(0, -0.65, 0)), // front view
		new Quaternion().setFromEuler(new Euler(-degresToRad(90), degresToRad(180), degresToRad(4))), // heel view
		new Quaternion().setFromEuler(new Euler(degresToRad(180), 0.05, 0)), // lattice view (flipped 180° to show bottom)
		new Quaternion().setFromEuler(new Euler(0, 0.05, 0)), // top view
	],
};

export const rightInsoleKeyframes: Keyframes = {
	positions: [
		new Vector3(-0.17, 0, -0.47), // front view
		new Vector3(0, 0, -0.05), // heel view
		new Vector3(-0.01, 0.55, 0.15), // lattice view (same position as top view)
		new Vector3(-0.01, 0.14, -0.05), // top view
	],
	rotations: [
		new Quaternion().setFromEuler(new Euler(0, -0.90, 0)), // front view
		new Quaternion().setFromEuler(new Euler(0, 0, 0)), // heel view
		new Quaternion().setFromEuler(new Euler(degresToRad(180), -0.05, 0)), // lattice view (flipped 180° to show bottom)
		new Quaternion().setFromEuler(new Euler(0, -0.05, 0)), // top view
	],
};
